export class UniAuthError extends Error {
  constructor(
    public readonly error: string,
    public readonly errorDescription: string,
    public readonly statusCode?: number
  ) {
    super(`[${error}] ${errorDescription}`)
    this.name = 'UniAuthError'
  }
}

export class AuthorizationError extends UniAuthError {
  constructor(error: string, description: string) {
    super(error, description, 403)
    this.name = 'AuthorizationError'
  }
}

export class TokenError extends UniAuthError {
  constructor(error: string, description: string) {
    super(error, description, 400)
    this.name = 'TokenError'
  }
}

export class NetworkError extends UniAuthError {
  constructor(message: string) {
    super('network_error', message)
    this.name = 'NetworkError'
  }
}

export class TimeoutError extends UniAuthError {
  constructor(message: string) {
    super('timeout_error', message)
    this.name = 'TimeoutError'
  }
}
